import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';

class Home extends Component {
	render() {
		const {
			currentUser,
			franchisor,
			t
		} = this.props;

		const canViewHeadOfficeReports = authUtils.hasPermission(currentUser, 'MasterFranchisees');
		if (canViewHeadOfficeReports) {
			return <Redirect to='/home/headOffice' />;
		}

		const canViewSalesReports = authUtils.hasPermission(currentUser, 'PaymentHistory');
		if (canViewSalesReports) {
			return <Redirect to='/home/sales' />;
		}

		const canViewOperationsReports = authUtils.hasPermission(currentUser, 'ChildLessons');
		if (canViewOperationsReports) {
			return <Redirect to='/home/operations' />;
		}

		const logoImg = franchisor.logoUrl || require('../../../theme/images/logo-ba.png');

		return <div style={{ margin: '100px 0px 0px' }}><Image responsive src={logoImg} style={{ display: 'block', margin: '0 auto' }} /></div>;
	}
}

const mapStateToProps = (state) => {
	const {
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	return {
		currentUser,
		franchisor
	};
};

export default connect(mapStateToProps, {
})(withTranslation()(Home));